import s from './style.module.scss';

import { Display } from '@/components/Display/Display';

import { fileTypeMap } from '@/utils/Page/constant';
import { Skeleton } from 'antd-mobile';
import MobileImgage from './Image';
import FileInfo from './FileInfo';
import { fileStatusDic } from '@/utils/Page/constant';
import { useRef } from 'react';
const ChatFile = ({ file }) => {
    const imgRef = useRef(null);
    const onClick = () => {
        if (file.type === fileTypeMap.link) {
            window.open(file.file_url);
        }
        if (file.type === fileTypeMap.img) {
            imgRef.current?.openImg();
        }
    };
    return (
        <>
            <div onClick={onClick} className={s['file-item']} data-from={'chat'}>
                <Display show={file.type === fileTypeMap.img}>
                    <div className={s['img-type-wrap']}>
                        <div className={s['left']}>
                            <Display show={file.status === fileStatusDic.ing}>
                                <Skeleton className={s['skeleton']} animated />
                            </Display>
                            <Display show={file.status !== fileStatusDic.ing}>
                                <MobileImgage ref={imgRef} file={file}></MobileImgage>
                            </Display>
                        </div>
                        <div className={s['right']}>
                            <FileInfo file={file}></FileInfo>
                        </div>
                    </div>
                </Display>
                <Display show={file.type === fileTypeMap.file || file.type === fileTypeMap.link}>
                    <div className={s['file-type-wrap']}>
                        <FileInfo file={file}></FileInfo>
                    </div>
                </Display>
            </div>
        </>
    );
};
export default ChatFile;
